import { ActivityRolesSummary } from "PFApp/activities/show/activity_page/parts/tabs/overview/activity_roles_summary";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { ActivityDetailsQuestions } from "PFApp/components/activity_commons/activity_details_questions";
import { Inline, Stack } from "PFComponents/containers";
import { useTranslation } from "react-i18next";

import { ActivitySummary } from "../../activity_summary/activity_summary";
import css from "./activity_overview.module.scss";
import { ActivityOverviewAttachments } from "./activity_overview_attachments";
import { ActivityOverviewAttributes } from "./activity_overview_attributes";
import { ActivityOverviewAvailability } from "./activity_overview_availability";
import { ActivityOverviewChats } from "./activity_overview_chats";
import { ActivityOverviewDescription } from "./activity_overview_description";
import { ActivityOverviewMatchAttributes } from "./activity_overview_match_attributes";
import { RollforwardInfoSection } from "./rollforward_info_section/rollforward_info_section";

export const ActivityOverview = () => {
  const { t } = useTranslation("activities");
  const activity = useCurrentActivity();

  return (
    <Inline
      className={css.activityOverview}
      gap="spacingXl"
      alignItems="start"
      role="tabpanel"
      aria-label={t("show.tabs.overview")}
      qaId="ActivityPage.overviewTab"
    >
      <ActivitySummary />
      <Stack className={css.activityOverviewRightSide} gap="spacingLg">
        <ActivityRolesSummary />
        <ActivityOverviewDescription />
        <RollforwardInfoSection />
        <ActivityOverviewMatchAttributes />
        <ActivityOverviewAttributes />
        <ActivityOverviewAvailability />
        <ActivityOverviewChats />
        <ActivityOverviewAttachments />
        <ActivityDetailsQuestions questions={activity.metadata.interest_questions} />
      </Stack>
    </Inline>
  );
};
